import { Moment } from 'moment';
import { ReactElement } from 'react';
import { TableColumn } from './TableHeaders';

export const CompetencesHeaderMobile = (fm) => {
  return [
    {
      label: fm({ id: 'common.table.vessel' }),
      key: 'vessel',
      sortKey: 'vesselValue',
    },
  ] as TableColumn<CompetenceRow>[];
};

export const CompetencesHeader = (fm) => {
  return [
    {
      label: fm({ id: 'common.table.vessel' }),
      key: 'vessel',
      sortKey: 'vesselValue',
    },
    {
      label: fm({ id: 'common.table.periode' }),
      key: 'period',
      sortFunction: (a, b) => {
        const startDiff = a.periodStart.diff(b.periodStart);
        if (startDiff !== 0) return startDiff;
        return a.periodEnd.diff(b.periodEnd);
      },
    },
    {
      label: fm({ id: 'competence.table.subheader3' }),
      key: 'additionalCompetende',
    },
  ] as TableColumn<CompetenceRow>[];
};

export interface CompetenceRow {
  vessel: ReactElement | string;
  vesselValue: string;
  additionalCompetende: string;
  period: string;
  periodStart: Moment;
  periodEnd: Moment;
}
